<template>
  <div>
    <div class="blockHeader">
        <div class="redBlock"></div>
        <div class="headerText">接入设备</div>
    </div>
    <div class="blockContent day">
        <div class="listContain">
            <div class="tablelistBody">
            <el-table
            :data="workEquipList"
            style="width: 100%"
            size="medium"
            v-loading="listLoading"
            >
                <el-table-column prop="name" label="设备名称"></el-table-column>
                <el-table-column prop="equipType" label="设备类型"></el-table-column>
                <el-table-column prop="workTime" label="设备累计作业时长(H)"></el-table-column>
                <el-table-column prop="mileage" label="设备累计行驶里程(km)"></el-table-column>
                <el-table-column prop="area" label="作业面积(m²)"></el-table-column>
                <el-table-column prop="icvPassRate" label="设备平均利用率">
                    <template slot-scope="scope">
                        <span>{{(scope.row.useRate * 100).toFixed(2) + '%'}}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="avgTemperature" label="平均摊铺温度(℃)"></el-table-column> -->
            </el-table>
        </div>
        </div>
    </div>
  </div>
</template>

<script>
  export default {
    name      : 'app',
    data() {
      return {
          listLoading: false
      }
    },
    props:{
        workEquipList: {
            type: Array,
            default: function () {
                return [];
            },
        },  
    },
    watch: {
        workEquipList: {
            handler(newVal) {
                console.log(newVal);
            
            },
            deep: true,
        },
    },
    computed:{

    },
    created(){

    },
    mounted(){

    },
    methods: {
        
    },
    components:{
            
    }
  }
</script>
<style lang="scss">
.day{
    .el-table__header-wrapper{
        height: 35px;
        // border:1px solid rgba(228, 231, 237, 1);
        .el-table__header{
            height: 35px !important;
            tr{
                th{
                    background-color: #EBEBEC !important;
                    color: #555555 !important;
                    font-size: 14px !important;
                    padding: 0 !important;
                    height: 35px !important;
                    font-weight: 400 !important;
                    text-align: center;
                }
            }
        }  
    }
    .el-table__body-wrapper{
        tr{
            td{
                text-align: center;
            }
        }
    }
}
    
</style>
<style lang="scss" scoped="">
    .blockHeader{
      width: 100%;
      height: 58px;
      position: relative;
      .redBlock{
          height: 18px;
          width: 4px;
          position: absolute;
          background-color: #E96B5A;
          top: 19px;
          left: 20px;
        }
        .headerText{
          height: 16px;
          line-height: 16px;
          color: #222222;
          display: inline-block;
          position: absolute;
          top: 21px;
          left: 34px;
          font-weight: 600;
        }
    }
    .listContain{
        width: 98.5%;
        margin: 0 auto;
    }
    
</style>